import { useCallback } from 'react';
import { logoutService } from '../services/authService';

const useLogout = () => {
    return useCallback(() => {
        const handleLogout = async () => {
            try {
                await logoutService();
            } catch (error) {
                console.error('Logout failed:', error);
            }
            finally {
                localStorage.clear();
                sessionStorage.clear();
                window.location.replace('/login');
            }
        };
        handleLogout();
    }, []);
};

export default useLogout;
